export default __webpack_public_path__ + "static/media/4T0A9367.a9612dd6.jpg";